import { create } from "zustand";

export const useCorrectiveActionStore = create((set, get) => ({
  // State
  correctiveActions: [],
  loading: false,
  error: null,
  selectedCorrectiveAction: null,
  searchQuery: "",
  filters: {},

  // Table features
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
  },

  // Modal / UI states
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  isDetailsOpen: false,
  correctiveActionToDelete: null,
  /** Prefill for new action (e.g. deep-link from management review) */
  actionCreatePrefill: null,

  // Basic Setters
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setCorrectiveActions: (correctiveActions) => set({ correctiveActions }),
  setSelectedCorrectiveAction: (action) => set({ selectedCorrectiveAction: action }),

  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setFilters: (filters) => set({ filters }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setPaginationData: (data) => set((state) => ({
    paginationData: {
      ...state.paginationData,
      ...data,
      currentPage: data.page || data.currentPage || state.paginationData.currentPage,
      itemsPerPage: data.pageSize || data.itemsPerPage || state.paginationData.itemsPerPage,
      totalItems: data.total || data.totalItems || state.paginationData.totalItems,
      totalPages: data.totalPages || state.paginationData.totalPages,
    }
  })),

  // UI Flow Actions
  openCreateForm: (prefill = null) => set({
    isFormOpen: true,
    isEditMode: false,
    selectedCorrectiveAction: null,
    actionCreatePrefill: prefill || null,
    error: null
  }),

  openEditForm: (action) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedCorrectiveAction: action,
    actionCreatePrefill: null,
    error: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    selectedCorrectiveAction: null,
    actionCreatePrefill: null,
    error: null
  }),

  openDeleteDialog: (action) => set({
    isDeleteDialogOpen: true,
    correctiveActionToDelete: action,
    error: null
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    correctiveActionToDelete: null,
    error: null
  }),

  openDetailsDialog: (action) => set({
    isDetailsOpen: true,
    selectedCorrectiveAction: action,
    error: null
  }),

  closeDetailsDialog: () => set({
    isDetailsOpen: false,
    selectedCorrectiveAction: null,
    error: null
  }),
}));
